import { useMutation, useQueryClient, type UseMutationOptions, type UseMutationResult } from '@tanstack/react-query';
import {
  updateProgramFeesPrizes,
  type UpdateProgramFeesPrizesParams,
  type UpdateProgramFeesPrizesResult
} from '../services/rpc/feesPrizes';

export function useUpdateProgramFeesPrizes(
  options?: UseMutationOptions<
    UpdateProgramFeesPrizesResult,
    Error,
    UpdateProgramFeesPrizesParams
  >
): UseMutationResult<UpdateProgramFeesPrizesResult, Error, UpdateProgramFeesPrizesParams> {
  const queryClient = useQueryClient();

  return useMutation<UpdateProgramFeesPrizesResult, Error, UpdateProgramFeesPrizesParams>({
    mutationFn: updateProgramFeesPrizes,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['program-report-card'] });
      queryClient.invalidateQueries({ queryKey: ['activity-log', variables.program_id] });
    },
    ...options
  });
}

export default useUpdateProgramFeesPrizes;
